<template>
  <div class="container-breakin-cupo">
    <div class="breking-cupo flex-wrap flex-lg-nowrap">
      <div class="d-flex align-items-center mr-3">
        <img src="@/assets/icons/icon-quac-large_blanco.svg" />
      </div>
      <p class="breakin-title-cupo pt-4 pt-md-0">
        <b>
          5 cuotas, 0% interes
        </b>
      </p>
      <p class="description-breakin-cupo py-3 py-lg-0">
        Compra hoy lo que te gusta y págalo en 5 cuotas quincenales, sin
        intereses ni aval.
      </p>
      <div class="container-button-cupo d-flex align-items-center">
        <a
          class="btn-cupo-brekin"
          target="_blank"
          href="/politica-alianza-quac-compra"
        >
          <b>Ver más</b>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BrakingCupo',
}
</script>
